export const FORM_ID = 'ProfileGoals--Insurance';

export const UPSERT_GOAL_URL = '/Consumer/GoalUpdate/SaveInsuranceGoal';

export interface InsuranceGoalData {}

export interface FormValues {
  assetBucketingIndices: number[];
}
